import { GenericTransaction } from './generic-transaction'

/**
 * Sum transaction amounts grouped by currency code
 */
export function getAmountsByCurrency(transactions: GenericTransaction[]) {
  return transactions.reduce<Map<string, number>>((prevValue, tran) => {
    if (tran.amountByCurrencyCode && !isCCWire(tran)) {
      getAmountsByCurrencyUsingMap(prevValue, tran.amountByCurrencyCode)
    } else {
      getAmountsByCurrencyWithoutUsingMap(prevValue, tran)
    }
    return prevValue
  }, new Map())
}

/** Sum transaction units */
export function sumUnits(transactions: GenericTransaction[]) {
  return transactions.reduce((prev, curr) => prev + (curr.units ?? 0), 0)
}

/** Sum marginEffect By currency*/
export function sumMarginEffectByCurrency(transactions: GenericTransaction[]) {
  return transactions.reduce<Map<string, number>>((prevValue, tran) => {
    getMarginEffectByCurrency(prevValue, tran)
    return prevValue
  }, new Map())
}

/**
 * Sum transaction amounts grouped by currency code when amountByCurrencyCode map not available.
 * @private
 */
function getAmountsByCurrencyWithoutUsingMap(
  prevValue: Map<string, number>,
  transaction: GenericTransaction,
) {
  const currencyCode = transaction.currencyCode ?? transaction.currency
  const amount = transaction.amount ?? 0
  if (currencyCode != null) {
    preValueCheckAndSet(prevValue, currencyCode, amount)
  }
}

/**
 * Sum cw transaction marginEffect grouped by currency code.
 */
function getMarginEffectByCurrency(
  prevValue: Map<string, number>,
  transaction: GenericTransaction,
) {
  const currencyCode = transaction.currencyCode ?? transaction.currency
  const amount = transaction.marginEffect ?? 0
  if (currencyCode != null) {
    preValueCheckAndSet(prevValue, currencyCode, amount)
  }
}

/**
 * Sum transaction amounts grouped by currency code for non fx transaction when amountByCurrencyCode available.
 * @private
 */
function getAmountsByCurrencyUsingMap(
  prevValue: Map<string, number>,
  transactionCurrencyMap: Map<string, number>,
) {
  for (const [currencyCode, amount] of Object.entries(transactionCurrencyMap)) {
    preValueCheckAndSet(prevValue, currencyCode, amount as number)
  }
}

/**
 * preValueCheckAndSet preValueCheckAndSet
 */
function preValueCheckAndSet(
  prevValue: Map<string, number>,
  currencyCode: string,
  amount: number,
) {
  if (prevValue.has(currencyCode)) {
    // Already checked that prevValue.get(currencyCode) id defined
    prevValue.set(currencyCode, (prevValue.get(currencyCode) ?? 0) + amount)
  } else {
    prevValue.set(currencyCode, amount)
  }
}

/**
 * if transaction is CCwire
 */
function isCCWire(transaction: GenericTransaction) {
  return (
    transaction.userName === 'perseus' &&
    transaction.typeLabel === 'Cash Consolidation' &&
    transaction.tranTypeCode === 'WIRE'
  )
}
